import { useEffect } from 'react';

function useHeaderHeight(
  ref: React.RefObject<HTMLElement>,
  isMobileView: boolean,
  newMastheadEnabled: boolean,
) {
  useEffect(() => {
    if (!ref?.current) return;

    const headerEl = ref.current;

    const updateHeight = () => {
      if (!headerEl) return;

      const height = headerEl.getBoundingClientRect().height || headerEl.offsetHeight;

      document.documentElement.style.setProperty('--header-height', (isMobileView && newMastheadEnabled)
        ? `${height + 48}px` : `${height}px`); // 48px for mobile view sub-navigation
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(headerEl);

    const mutationObserver = new MutationObserver(updateHeight);
    mutationObserver.observe(headerEl, { childList: true, subtree: true });

    // eslint-disable-next-line consistent-return
    return () => {
      resizeObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, [ref, isMobileView, newMastheadEnabled]);
}

export default useHeaderHeight;
